import { ORDER_ITEM_TYPE } from 'schema/subscription/orderItemType';

const { SUBSCRIPTION, NEXT_ORDER, TO_BE_APPLIED_AFTER_NEXT_ORDER } = ORDER_ITEM_TYPE;

export const isSubscriptionOrderItem = (orderItemType?: ORDER_ITEM_TYPE) =>
  orderItemType === SUBSCRIPTION;

export const isNextOrderOnlyOrderItem = (orderItemType?: ORDER_ITEM_TYPE) =>
  orderItemType === NEXT_ORDER;

export const isAppliedAfterNextOrderOnlyOrderItem = (orderItemType?: ORDER_ITEM_TYPE) =>
  orderItemType === TO_BE_APPLIED_AFTER_NEXT_ORDER;
